module.exports = __webpack_public_path__ + "img/practice-1.938a4f66.jpg";